var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"runnit-reroute"},[_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }